import React, { useState, useEffect } from 'react';
import PageLayout from '../components/PageLayout';
import styles from '../styles/Webtable.module.css';

const Webtable = () => {
  const employees = [
    { id: '101', name: 'MURUGAN', role: 'ADMIN', salary: '16,000/-', dept: '#3840', email: 'MURUGAN@BSPARK.COM' },
    { id: '103', name: 'RAJA', role: 'TECH SUPPORT', salary: '20,000/-', dept: '#3072', email: 'RAJA@BSPARK.COM' },
    { id: '102', name: 'BALAJI', role: 'ADMIN', salary: '16,000/-', dept: '#3840', email: 'BALAJI@BSPARK.COM' },
    { id: '104', name: 'TAMIL', role: 'HR', salary: '27,000/-', dept: '#3056', email: 'TAMIL@BSPARK.COM' },
    { id: '106', name: 'VIKRAM', role: 'TECH SUPPORT', salary: '20,000/-', dept: '#3072', email: 'VIKRAM@BSPARK.COM' },
    { id: '105', name: 'ANISH', role: 'ADMIN', salary: '16,000/-', dept: '#3840', email: 'ANISH@BSPARK.COM' },
    { id: '107', name: 'BHUVAN', role: 'TECH SUPPORT', salary: '20,000/-', dept: '#3072', email: 'BHUVAN@BSPARK.COM' },
    { id: '109', name: 'SARAN', role: 'ADMIN', salary: '16,000/-', dept: '#3840', email: 'SARAN@BSPARK.COM' },
    { id: '110', name: 'SETHU', role: 'HR', salary: '27,000/-', dept: '#3056', email: 'SETHU@BSPARK.COM' },
    { id: '108', name: 'RAJKUMAR', role: 'TECH SUPPORT', salary: '20,000/-', dept: '#3072', email: 'RAJKUMAR@BSPARK.COM' },
  ];

  const contentPoints = [
    'GET THE COUNT OF NUMBER OF COLUMN',
    'GET THE COUNT OF NUMBER OF ROWS',
    'GET THE EMPLOYEE ID OF TAMIL',
    'GET THE JOB ROLE OF RAJA',
    'GET THE STATUS OF MURUGAN',
  ];

  const [query, setQuery] = useState('');
  const [jobRole, setJobRole] = useState('');
  const [filteredData, setFilteredData] = useState(employees);
  const [sortAsc, setSortAsc] = useState(true);

  // ✅ Automatic filtering
  useEffect(() => {
    const lower = query.toLowerCase();
    const result = employees.filter(emp => {
      const matchesNameOrEmail = emp.name.toLowerCase().includes(lower) || emp.email.toLowerCase().includes(lower);
      const matchesRole = jobRole ? emp.role === jobRole : true;
      return matchesNameOrEmail && matchesRole;
    });
    setFilteredData(result);
  }, [query, jobRole]);

  // ✅ Sorting handler
  const handleSortById = () => {
    const sorted = [...filteredData].sort((a, b) =>
      sortAsc ? Number(a.id) - Number(b.id) : Number(b.id) - Number(a.id)
    );
    setFilteredData(sorted);
    setSortAsc(!sortAsc);
  };

  return (
    <PageLayout
      title="📊 EMPLOYEE WEBTABLE"
      sidebarContent={
        <div className={styles.sidebarContent}>
          <label><b><u>CONTENT</u></b></label>
          <ul>{contentPoints.map((text, i) => <li key={'content' + i}>{text}</li>)}</ul>
          <label><b><u>TASKS</u></b></label>
          <ul>{contentPoints.map((text, i) => <li key={'task' + i}>{text}</li>)}</ul>
        </div>
      }
    >
      <div className={styles.card}>
        {/* Search + Dropdown */}
        <div style={{ display: 'flex', gap: '8px', marginBottom: '12px' }}>
          <input
            type="text"
            placeholder="Search Name or Email"
            value={query}
            onChange={e => setQuery(e.target.value)}
            style={{ padding: '8px', borderRadius: '6px', flex: 1 }}
          />
          <select
            value={jobRole}
            onChange={e => setJobRole(e.target.value)}
            style={{ padding: '8px', borderRadius: '6px', flex: 1 }}
          >
            <option value="">All Roles</option>
            <option value="ADMIN">ADMIN</option>
            <option value="TECH SUPPORT">TECH SUPPORT</option>
            <option value="HR">HR</option>
          </select>
        </div>

        {/* Sort Button */}
        <button
          onClick={handleSortById}className={styles.buttonSort}
        >
          Sort by ID {sortAsc ? '↑' : '↓'}
        </button>

        {/* Table */}
        
    
       <div className={`table-responsive ${styles.tableWrapper}`}>
          <table className={`table table-bordered table-hover ${styles.table}`} id="webtable">
            <thead>
              <tr>
                <th onClick={handleSortById} style={{ cursor: 'pointer' }}>
                  EMPLOYEE ID {sortAsc ? '↑' : '↓'}
                </th>
                <th>NAME</th>
                <th>JOB ROLE</th>
                <th>SALARY</th>
                <th>DEPARTMENT ID</th>
                <th>EMAIL</th>
                <th>STATUS</th>
              </tr>
            </thead>
            <tbody>
               {filteredData.length > 0 ? (
                filteredData.map((emp, index) => (
                <tr key={index}>
                  <td>{emp.id}</td>
                  <td>{emp.name}</td>
                  <td>{emp.role}</td>
                  <td>{emp.salary}</td>
                  <td>{emp.dept}</td>
                  <td>{emp.email}</td>
                  <td>
                    <input type="checkbox" name="active" id={`active-${emp.id}`} /> ACTIVE
                  </td>
                </tr>
              ))
            ):(
              <tr>
              <td colSpan="7" className={styles.noRecords}>
                  🚫 No records found
              </td>
            </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </PageLayout>
  );
};

export default Webtable;